import { inject, Injectable } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { ReleaseNotesDialogComponent } from '../dialogs/release-notes-dialog/release-notes-dialog.component';
import { GlobalStore } from '../store/global.store';
import { ModalService } from './modal.service';

@Injectable({
  providedIn: 'root',
})
export class ReleaseNotesDialogService {
  private readonly globalStore = inject(GlobalStore);
  private readonly modalService = inject(ModalService);

  private dialogRef: DynamicDialogRef;

  public openRelaseNotesDialog(closable: boolean, actionsEnabled: boolean): void {
    this.dialogRef = this.modalService.showDialog(ReleaseNotesDialogComponent, {
      width: '60rem',
      height: '50rem',
      styleClass: 'release-notes-dialog',
      dismissableMask: closable,
      closable: closable,
      header: "What's new? 🚀",
      data: {
        releaseNote: this.globalStore.releaseNoteInfo,
        isLoading: this.globalStore.releaseNoteLoading,
        controlsShown: actionsEnabled,
        onAccept: () => {
          if (actionsEnabled) {
            this.acceptReleaseNote();
          }
          this.dialogRef.close();
        },
        onCancel: () => {
          if (actionsEnabled) {
            this.calcelReleaseNote();
          }
        },
      },
    });
  }

  public destroyDialog(): void {
    this.dialogRef?.destroy();
  }

  private acceptReleaseNote(): void {
    this.globalStore.setReleaseNoteStatus(true);
  }

  private calcelReleaseNote(): void {
    this.globalStore.setReleaseNoteStatus(false);
  }
}
